export default "__VITE_ASSET__FOISD2sq__"